import store from "../store/store";
import pWaitFor from "p-wait-for";
import {tabSession} from '../Auth/session';
import {formatLFM} from "../Contacts/ContactFormat";
import {getCurrentFirmId, getCurrentUserId} from "./picos/currentLogin";
import {setFaroUser} from "./faro";
import {globalAbortSignal, ignoreGlobalAbort} from "./picos/abortController";
import {startRecording} from './sessionReplay';

/**
 * Should we cancel the loop?
 */
let canceled = false;

/**
 * Check to see if all necessary identification information is present at this moment.
 */
function doCheck() {
	// See what information is available.
	const firmId = getCurrentFirmId();
	if (!firmId) return false;

	// USER_ID, not USER_FIRM_ID: the fallback was reading the firm key, so the
	// user lookup below could never resolve and remote logging stayed
	// unidentified for the whole session.
	const userId = getCurrentUserId();
	if (!userId) return false;

	const firm = store.getState().firms.get(firmId);
	if (!firm) return false;

	const user = store.getState().users.get(userId);
	if (!user) return false;

	const contact = store.getState().contacts.get(user.contactId);
	if (!contact) return false;

	const name = formatLFM(contact);
	if (!name) return false;

	return {firmId, userId, name, email: user.email};
}

/**
 * If we have the information needed to initialize and identify the user, do it.
 */
export function setLoggingUser() {
	if (!tabSession.isLocalReady()) return;
	const operation = tabSession.capture();
	// Wait until we have all the information we require
	pWaitFor(() => !canceled && !!doCheck(), {interval: 1000, signal: AbortSignal.any([globalAbortSignal, operation.signal])})
		.then(() => {
			operation.assertCurrent();
			const checkResults = doCheck();
			if (checkResults) {
				const {firmId, userId, name, email} = checkResults;

				setFaroUser(userId, firmId);
			startRecording(userId, firmId);
			}
		})
		// This wait polls forever with no timeout, so it is routinely still
		// pending at logout; without this it becomes an unhandled rejection.
		.catch(ignoreGlobalAbort);
}
